import zoomIn from "../../../../../../../assets/images/svg/zoom-in.svg";
import zoomOut from "../../../../../../../assets/images/svg/zoom-out.svg";

const ImageReaderFooter = ({ scale, setScale }: any) => {
    return (
        <div className="fixed bottom-3 mr-0 flex justify-center">
            <img
                src={zoomIn}
                alt="zoom-in"
                className="cursor-pointer"
                onClick={() => {
                    if (scale < 4) {
                        setScale(scale + 0.5);
                    }
                }}
            />
            <img
                src={zoomOut}
                alt="zoom-out"
                className="cursor-pointer mr-2"
                onClick={() => {
                    if (scale > 1) {
                        setScale(scale - 0.5);
                    }
                }}
            />
        </div>
    );
};

export default ImageReaderFooter;
